var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonProvider } from '../../providers/common/common';
import { Events } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import JsBarcode from 'jsbarcode';
var MemberCardComponent = /** @class */ (function () {
    function MemberCardComponent(comProv, events, translate) {
        var _this = this;
        this.comProv = comProv;
        this.events = events;
        this.translate = translate;
        this.returnDispBarcode = new EventEmitter();
        this.service_data = [];
        this.card_data = [];
        this.user_data = [];
        this.clock = this.comProv.getClock();
        this.disp_barcode = false;
        this.is_bright = false;
        this.text_member_unregistered = this.translate.get('text_member_unregistered')['value'];
        this.noset_height = '70px';
        this.service_data = this.comProv.getService();
        this.card_data = this.service_data['app_membership_card'];
        this.user_data = this.comProv.getUser();
        this.is_login = this.comProv.isLogin();
        this.is_app = this.comProv.isApp();
        this.events.subscribe('member-card:dark', function () {
            _this.setDark();
            clearInterval(_this.interval_clock);
        });
    }
    MemberCardComponent.prototype.ngOnInit = function () {
        console.log('ngOnInit');
        if (this.page_name == 'member') {
            this.noset_height = '100px';
        }
    };
    MemberCardComponent.prototype.ngAfterContentInit = function () {
        this.dispBarcode();
    };
    MemberCardComponent.prototype.ngOnDestroy = function () {
        this.setDark();
        clearInterval(this.interval_clock);
    };
    MemberCardComponent.prototype.changeMemberCode = function (member_code) {
        console.log('changeMemberCode', member_code);
        this.user_data['member_code'] = member_code;
        if (this.user_data['member_code']) {
            this.dispBarcode();
        }
        else {
            this.setDark();
            this.disp_barcode = false;
            this.text_member_unregistered = this.translate.get('text_member_unregistered')['value'];
            this.returnDispBarcode.emit(this.disp_barcode);
        }
    };
    MemberCardComponent.prototype.dispBarcode = function () {
        var _this = this;
        if (this.card_data['is_barcode'] != 1) {
            return;
        }
        if (!this.is_login) {
            return;
        }
        if (!this.card_data['barcode_format']) {
            if (this.page_name == 'member') {
                this.comProv.dispAlert('バーコードのフォーマットが設定されていません。');
            }
            return;
        }
        if (!this.card_data['is_user_id_barcode']) {
            if (!this.user_data['member_code']) {
                return;
            }
            if (!this.comProv.checkBarcodeFormat(this.user_data['member_code'])) {
                //this.comProv.dispAlert(this.translate.get('message_member_barcode_not_matching')['value']);
                this.text_member_unregistered = this.translate.get('message_member_barcode_not_matching')['value'];
                return;
            }
        }
        try {
            var height = 50;
            if (this.page_name == 'wfk') {
                height = 90;
            }
            var barcode_style = {
                format: this.card_data['barcode_format'],
                fontSize: 16,
                height: height,
                margin: 5,
            };
            var barcode_string = '';
            if (this.card_data['is_user_id_barcode']) {
                if (this.service_data['option']['member_barcode_pattern']) {
                    barcode_string = this.comProv.generateBarcodeString(this.user_data['id'], this.service_data['option']['member_barcode_pattern'], this.card_data['barcode_format']);
                }
                else {
                    barcode_string = this.user_data['id'];
                }
            }
            else {
                barcode_string = this.user_data['member_code'];
            }
            JsBarcode('#barcode_id', barcode_string, barcode_style);
            /*if (this.card_data['is_user_id_barcode']) {
              JsBarcode('#barcode_id', this.user_data['id'], barcode_style);
            } else {
              JsBarcode('#barcode_id', this.user_data['member_code'], barcode_style);
            }*/
            this.disp_barcode = true;
            this.returnDispBarcode.emit(this.disp_barcode);
            if (this.page_name != 'home') {
                this.interval_clock = setInterval(function () {
                    _this.clock = _this.comProv.getClock();
                }, 1000);
            }
            if (this.page_name == 'member') {
                setTimeout(function () {
                    _this.setBright();
                }, 100);
            }
        }
        catch (e) {
            //this.comProv.dispAlert(this.translate.get('message_member_barcode_not_matching')['value']);
            this.text_member_unregistered = this.translate.get('message_member_barcode_not_matching')['value'];
        }
    };
    MemberCardComponent.prototype.changeBright = function () {
        if (this.is_bright) {
            this.setDark();
        }
        else {
            this.setBright();
        }
    };
    MemberCardComponent.prototype.setBright = function () {
        if (this.page_name == 'coupon') {
            return;
        }
        if (!this.disp_barcode) {
            return;
        }
        if (!this.is_app) {
            return;
        }
        if (this.is_bright) {
            return;
        }
        this.is_bright = true;
        this.comProv.setBright();
    };
    MemberCardComponent.prototype.setDark = function () {
        if (this.page_name == 'coupon') {
            return;
        }
        if (!this.is_app) {
            return;
        }
        if (!this.is_bright) {
            return;
        }
        this.is_bright = false;
        this.comProv.setDark();
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], MemberCardComponent.prototype, "page_name", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], MemberCardComponent.prototype, "returnDispBarcode", void 0);
    MemberCardComponent = __decorate([
        Component({
            selector: 'member-card',
            templateUrl: 'member-card.html'
        }),
        __metadata("design:paramtypes", [CommonProvider,
            Events,
            TranslateService])
    ], MemberCardComponent);
    return MemberCardComponent;
}());
export { MemberCardComponent };
//# sourceMappingURL=member-card.js.map


// WEBPACK FOOTER //
// ./src/components/member-card/member-card.ts.pre-build-optimizer.js